import api from "./axios";
import { http } from "./client";

export const fetchDocuments = (ReferralId) =>
    http.get("Documents", { params: { ReferralId, timestamp: Date.now() } });

export const uploadDocuments = async ({ applicationId, files }) => {
    const formData = new FormData();

    formData.append("ReferralId", applicationId);

    files.forEach((item, index) => {
        formData.append(`Files[${index}].File`, item.file);
        formData.append(`Files[${index}].FormTypeID`, item.typeID);
    });

    const response = await api.post("Documents/add", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });

    return response.data;
};

export const downloadDocument = async ({ DocumentId, onDownloadProgress }) => {
    const response = await api.get("Documents/get", {
        params: { DocumentId },
        responseType: "blob",
        onDownloadProgress
    });

    return response.data;
};

export const deleteDocument = ({ DocumentId }) =>
    http.delete("Documents/delete", { DocumentId });
